import React from 'react';
import { useParams } from 'react-router-dom';

import DocumentsTable from 'components/shared/DocumentsTable/DocumentsTable';

const Attachments = () => {
  const { appointmentId } = useParams();

  const options = {
    enableDocumentEdit: true,
    enableDocumentMarkup: true,
    enableDocumentSharing: true,
    enableAppointmentLinking: false,
    showImportantDocuments: false,
    showSendPatientForms: false,
    appointmentId,
    enableTags: true,
    enableSendAsFax: true,
    enableShareWithPractice: true
  };

  return <DocumentsTable level="attachment" options={options} />;
};

export default Attachments;
